// PenIcon.tsx
import { Icon, IconProps } from "@chakra-ui/react";

export const PenIcon = (props: IconProps) => (
  <Icon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M10.7279 2.23723C11.3489 1.56442 11.6594 1.22801 11.9893 1.03179C12.7855 0.558315 13.7657 0.543591 14.5751 0.992951C14.9106 1.17918 15.2306 1.50612 15.8707 2.15998C16.5108 2.81385 16.8308 3.14078 17.0131 3.48345C17.453 4.31028 17.4386 5.31168 16.9751 6.12493C16.783 6.46198 16.4537 6.77916 15.7951 7.41352L7.95869 14.9613C6.71057 16.1634 6.0865 16.7645 5.30655 17.0691C4.5266 17.3738 3.66917 17.3513 1.95431 17.3065L1.72099 17.3004C1.19893 17.2867 0.937895 17.2799 0.786159 17.1077C0.634423 16.9355 0.655139 16.6696 0.69657 16.1378L0.719067 15.8491C0.835678 14.3523 0.893983 13.6039 1.18626 12.9312C1.47854 12.2585 1.9827 11.7122 2.99103 10.6198L10.7279 2.23723Z"
      stroke="white"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M9.8335 2.33398L15.6668 8.16732"
      stroke="white"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M10.6665 17.334L17.3332 17.334"
      stroke="white"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
